import JsEncrypt from 'jsencrypt'

const ENCRYPT_PUBLIC_KEY =
  'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzTdAbjenLOAV2XBsDqXCRlngWwdq5BbAhKx0BNuzYxYA8dNbKCXO7k4V6nKH1J8wVjTjmj3NPKo+hfS2B+hfK3N+AXN+i4Z0YWE5hqCfO6Xb/JSmVU2n7UDv0qLeQMc8jH5Vk9h7TbwzHS8+2cx/jnNtoxSyF1TQ5l0TqKdBCjb9vkqmmsU0I4NwfxZz0e5wyemlog0mioGDHcDJ0qu+C7pdtQszY2rVxVzI2ux+y7VrzxcgNsOax4qTxfoaeWq/00eVBlcZNzScFkru8M+mqbY1K+NRGUeDW3x4rofr1NEXiekiNgIagS7XNgpncxZczWIEDX5PkZl+GXuHhFj9NQIDAQAB'

const RSAencrypt = (pas: string, publicKey: string = ENCRYPT_PUBLIC_KEY) => {
  //实例化jsEncrypt对象
  const jse = new JsEncrypt()
  //设置公钥
  jse.setPublicKey(publicKey)
  // console.log('加密：'+jse.encrypt(pas))
  return jse.encrypt(pas)
}

const encryptTools = { RSAencrypt }

export default encryptTools
